import { createFileRoute } from "@tanstack/react-router";
import { PowerBiReport } from "@/features/compliance-dashboard";

const Route = createFileRoute("/_authorized/compliance-dashboard/")({
  component: () => <PowerBiReport />,
});

export { Route };
